

import { Component, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { WPXFormValue } from '@/components/templates/WPXForm';
import CreateTeamForm from '@/services/Dossier/team/forms/CreateTeamForm';
import { UserBaseInfoInterface, UserRepoInterface } from '@/services/Users/Interfaces';
import DossierTeamRepository from '@/services/Dossier/team';
import DossierUserRepositoryInterface, { AgentInterface } from '@/services/Dossier/user/interfaces';

@Component({
  mixins: [
    Themeable,
  ],
  inject: [
    'dossierUserRepository',
    'dossierTeamRepository',
    'userRepository',
  ],
})
export default class CreateTeam extends Vue {
  private form: WPXFormValue<CreateTeamForm> = new WPXFormValue(CreateTeamForm);

  private dossierUserRepository!: DossierUserRepositoryInterface;
  private dossierTeamRepository!: DossierTeamRepository;
  private userRepository!: UserRepoInterface;

  private loading: boolean = true;

  private users: AgentInterface[] = [];
  private usersMap: { [key: string]: UserBaseInfoInterface } = {};

  private async created(): Promise<void> {
    await this.initialize();
  }

  private async initialize(): Promise<void> {
    try {
      this.users = await this.dossierUserRepository.getAllFreeUsers();
      await this.getUsersProfiles();
      this.loading = false;
    } catch (e) {
      this.$errorDialog.show(e?.response?.data?.message || e.message);
    }
  }

  private async getUsersProfiles(): Promise<void> {
    const users = await this.userRepository.getUsersByIds(this.users.map((user) => user.id));
    users.forEach((user) => {
      this.usersMap[user.id] = user;
    });
  }

  private async createTeam(): Promise<void> {
    try {
      await this.dossierTeamRepository.createTeam(this.form.data.managerId);
      this.$successDialog.show('Team Created Successfully!');
      await this.$router.push({ name: 'all-teams' });
    } catch (e) {
      this.$errorDialog.show(e?.response?.data?.message || e.message);
    }
  }

  private async goBack(): Promise<void> {
    await this.$router.push({ name: 'all-teams' });
  }
}
